// ─────────────────────────────────────────────────────────────────────────────
// Aliases Actions
// ─────────────────────────────────────────────────────────────────────────────
// NgRx actions for the product aliases store slice.
// Covers CRUD, bulk delete, loading state, search, and filter actions.
// ─────────────────────────────────────────────────────────────────────────────

import { createAction, props } from '@ngrx/store';
import { APIResponse } from 'src/app/core/models/api-response';
import { IPageCount } from 'src/app/shared/models/page.model';
import { AliasFilters, ICreateAliasPayload, IProductAlias, IUpdateAliasPayload } from '../models/alias.models';

// ── Load aliases ─────────────────────────────────────────────────────────────

export const LoadAliases = createAction(
  '[ Aliases ] - LoadAliases',
  props<{ page: IPageCount; key?: string; filters?: AliasFilters; sortBy?: string; sortMode?: 'asc' | 'desc' }>(),
);
export const LoadAliasesSuccess = createAction('[ Aliases ] - LoadAliases Success ', props<{ response: APIResponse<IProductAlias> }>());
export const LoadAliasesError = createAction('[ Aliases ] - LoadAliases Error');

// ── Create alias ─────────────────────────────────────────────────────────────

export const CreateAlias = createAction('[ Alias ] - CreateAlias', props<{ payload: ICreateAliasPayload }>());
export const CreateAliasSuccess = createAction('[ Alias ] - CreateAlias Success ', props<{ alias: IProductAlias }>());
export const CreateAliasError = createAction('[ Alias ] - CreateAlias Error');

// ── Update alias ─────────────────────────────────────────────────────────────

export const UpdateAlias = createAction('[ Alias ] - UpdateAlias', props<{ id: number; payload: IUpdateAliasPayload }>());
export const UpdateAliasSuccess = createAction('[ Alias ] - UpdateAlias Success ', props<{ alias: IProductAlias }>());
export const UpdateAliasError = createAction('[ Alias ] - UpdateAlias Error');

// ── Delete alias ─────────────────────────────────────────────────────────────

export const DeleteAlias = createAction('[ Alias ] - DeleteAlias', props<{ id: number }>());
export const DeleteAliasSuccess = createAction('[ Alias ] - DeleteAlias Success ');
export const DeleteAliasError = createAction('[ Alias ] - DeleteAlias Error');

// ── Bulk delete aliases ──────────────────────────────────────────────────────

export const BulkDeleteAliases = createAction('[ Aliases ] - BulkDeleteAliases', props<{ ids: number[] }>());
export const BulkDeleteAliasesSuccess = createAction('[ Aliases ] - BulkDeleteAliases Success ');
export const BulkDeleteAliasesError = createAction('[ Aliases ] - BulkDeleteAliases Error');

// ── Loader ───────────────────────────────────────────────────────────────────

export const SetAliasesLoader = createAction('[ Aliases ] - SetLoading', props<{ isLoading: boolean }>());

// ── Search ───────────────────────────────────────────────────────────────────

export const SetAliasSearch = createAction('[ Aliases ] - SetSearch', props<{ keyword: string }>());

// ── Filters ──────────────────────────────────────────────────────────────────

export const SetAliasFilters = createAction('[ Aliases ] - SetFilters', props<{ filters: AliasFilters }>());
